import React, { createContext, useContext, useState } from "react";

const PlannerContext = createContext(null);

const PlannerProvider = ({ children }) => {
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [validateStart, setValidateStart] = useState(0);
  const [validateEnd, setValidateEnd] = useState(0);
  const [errors, setErrors] = useState(0);
  const [connectionTypes, setConnectionTypes] = useState(null);
  const [buildingsTypes, setBuildingsTypes] = useState(null);
  const [property, setProperty] = useState(null);

  return (
    <PlannerContext.Provider
      value={{
        nodes,
        setNodes,
        edges,
        setEdges,
        validateStart,
        setValidateStart,
        validateEnd,
        setValidateEnd,
        errors,
        setErrors,
        connectionTypes,
        setConnectionTypes,
        property,
        setProperty,
        buildingsTypes,
        setBuildingsTypes,
      }}
    >
      {children}
    </PlannerContext.Provider>
  );
};

const usePlannerContext = () => {
  return useContext(PlannerContext);
};

export { PlannerProvider, usePlannerContext };
